(function () {
  'use strict';
  function shippingMessage(now) {
    var parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',hourCycle:'h23'}).formatToParts(now);
    var p = {}; parts.forEach(function (x) { p[x.type] = Number(x.value); });
    var date = new Date(Date.UTC(p.year,p.month-1,p.day));
    var day = date.getUTCDay();
    function fixed(m,d) {
      var h = new Date(Date.UTC(p.year,m-1,d));
      if (h.getUTCDay()===6) h.setUTCDate(h.getUTCDate()-1);
      if (h.getUTCDay()===0) h.setUTCDate(h.getUTCDate()+1);
      return h.getTime()===date.getTime();
    }
    function nth(m,weekday,n) { return p.month===m && day===weekday && Math.ceil(p.day/7)===n; }
    var nextNewYear = p.month===12 && p.day===31 && new Date(Date.UTC(p.year+1,0,1)).getUTCDay()===6;
    var holiday = fixed(1,1)||fixed(6,19)||fixed(7,4)||fixed(11,11)||fixed(12,25)||nextNewYear||nth(1,1,3)||nth(2,1,3)||(p.month===5&&day===1&&p.day+7>31)||nth(9,1,1)||nth(10,1,2)||nth(11,4,4);
    if (day===0 || day===6 || holiday || p.hour>=15) return {text:'Ships next business day.',today:false};
    var minutes = 15*60-p.hour*60-p.minute;
    var remaining = (Math.floor(minutes/60) ? Math.floor(minutes/60)+'h ' : '') + minutes%60+'m';
    return {text:'Order within '+remaining+' to ship today.',today:true,remaining:remaining};
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports={shippingMessage:shippingMessage}; return; }
  if (window.epfDispatchInstalled) return;
  window.epfDispatchInstalled=true;
  function update() {
    document.querySelectorAll('[data-epf-dispatch]').forEach(function (marker) {
      var root=marker.closest('.product-info');
      if (!root) return;
      var stock=root.querySelector('.product-info__inventory');
      if (!stock) return;
      var card=root.querySelector('.epf-shipping-card');
      var ground=root.querySelector('.epf-ground-product');
      var stockBlock=stock.closest('.product-info__block-item');
      var groundBlock=ground && ground.closest('.product-info__block-item');
      if (!card && stockBlock && groundBlock && stockBlock.parentElement===groundBlock.parentElement) {
        card=document.createElement('div');
        card.className='epf-shipping-card';
        stockBlock.parentElement.insertBefore(card,stockBlock);
        card.appendChild(stockBlock);
        card.appendChild(groundBlock);
      }
      var existing=(card || stock).querySelector('.epf-dispatch-message');
      var label=stock.querySelector('.epf-dispatch-label');
      var variants;
      try { variants=JSON.parse(marker.getAttribute('data-variants')); } catch (_) { return; }
      var form=document.getElementById(marker.getAttribute('data-form'));
      var selected=form && form.querySelector('[name="id"]');
      var id=selected ? String(selected.value) : marker.getAttribute('data-selected');
      var eligible=/^(FB|FM|CRF)[0-9]/i.test(marker.getAttribute('data-part')||'') && variants.some(function(v){return v.id===id && v.eligible===true;});
      if (!eligible) {
        if(existing) existing.remove();
        if(label) label.remove();
        stock.classList.remove('epf-stock-with-dispatch');
        return;
      }
      if (!existing) {
        existing=document.createElement('span');
        existing.className='epf-dispatch-message';
        (card || stock).appendChild(existing);
      }
      stock.classList.add('epf-stock-with-dispatch');
      var message=shippingMessage(new Date());
      if (card) {
        if (!label) {
          label=document.createElement('span');
          label.className='epf-dispatch-label';
          stock.appendChild(label);
        }
        var heading=message.today ? 'Ships today' : 'Ships next business day';
        if(label.textContent!==heading) label.textContent=heading;
      }
      if (existing.getAttribute('data-message')!==message.text) {
        existing.setAttribute('data-message',message.text);
        existing.textContent='';
        if(message.today) {
          existing.appendChild(document.createTextNode('Order within '));
          var time=document.createElement('strong');
          time.textContent=message.remaining;
          existing.appendChild(time);
          existing.appendChild(document.createTextNode(' to ship today.'));
        } else existing.textContent=message.text;
      }
      if(card) existing.hidden=!message.today;

    });
  }
  var style=document.createElement('style');
  style.textContent=".product-info__inventory.epf-stock-with-dispatch{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:4px 12px}.epf-dispatch-message{font-size:12px;line-height:1.4;color:#334155;font-weight:500;font-variant-numeric:tabular-nums}.epf-dispatch-message strong{font-size:15px;font-weight:750;color:#111827}.product-info .epf-shipping-card{background:#f5f7f9;border:1px solid #dce2e8;border-radius:12px;padding:10px 12px;margin:8px 0 10px}.product-info .epf-shipping-card>.product-info__block-item{margin:0!important;padding:0!important;width:100%!important;max-width:none!important}.product-info .epf-shipping-card .product-info__inventory{margin:0;padding:0;font-size:13px;line-height:1.4}.epf-shipping-card .epf-dispatch-label{font-size:13px;font-weight:650;color:#111827;border-left:1px solid #dce2e8;padding-left:16px}.product-info .epf-shipping-card .epf-ground-product{border-top:1px solid #dce2e8;margin:7px 0 0;padding:7px 0 0;gap:8px}.product-info .epf-shipping-card .epf-ground-product strong{font-size:16px;line-height:1.3;color:#111827!important;font-weight:750!important}.epf-shipping-card .epf-ground-copy small{font-size:12px;line-height:1.3}.epf-shipping-card .epf-ground-product svg{width:25px;height:25px;flex-basis:25px}.product-info .epf-shipping-card>.epf-dispatch-message{display:block;border-top:1px solid #dce2e8;padding-top:7px;margin-top:7px;font-size:13px;text-align:left}.product-info .epf-shipping-card>.epf-dispatch-message[hidden]{display:none}@media(max-width:699px){.product-info .epf-shipping-card{padding:9px 10px}.epf-shipping-card .epf-dispatch-label{font-size:12px;padding-left:10px}.product-info .epf-shipping-card .epf-ground-product strong{font-size:15px}.product-info .epf-shipping-card>.epf-dispatch-message{font-size:12px}.epf-dispatch-message strong{font-size:14px}}";
  document.head.appendChild(style);
  update();
  document.addEventListener('change',update);
  new MutationObserver(update).observe(document.body,{childList:true,subtree:true});
  setInterval(update,15000);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)update();});
})();
